import {createContext} from 'react';

type MatrixUnreadEventsContextType = {
  unreadEventsCount: number;
  lastReadEvent: string | null;
};

const defaultContext: MatrixUnreadEventsContextType = {
  unreadEventsCount: 0,
  lastReadEvent: null
};

const MatrixUnreadEventsContext =
  createContext<MatrixUnreadEventsContextType>(defaultContext);

export default MatrixUnreadEventsContext;
